"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasBboxSelected = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var utils_1 = require("../../utils");
var draw_bbox_1 = require("../functions/draw/draw-bbox");
exports.CanvasBboxSelected = (0, react_1.memo)(function (_a) {
    var bboxStyle = _a.bboxStyle, canvasSize = _a.canvasSize, selectedBbox = _a.selectedBbox, _b = _a.mode, mode = _b === void 0 ? 'rectbox-editor-standby' : _b;
    var _c = tslib_1.__read((0, utils_1.useCanvasContext2d)(), 2), context = _c[0], canvasRef = _c[1];
    (0, react_1.useEffect)(function () {
        if (context === undefined)
            return;
        (0, utils_1.resetAndDrawOnCanvas)(context, canvasSize, function () {
            if (selectedBbox !== undefined &&
                mode !== 'rectbox-editor-add-bbox' &&
                mode !== 'auto-segmentation-crop') {
                var h = selectedBbox.label.hue;
                var _a = tslib_1.__read(bboxStyle.borderColorSLA.selected, 3), s = _a[0], l = _a[1], a = _a[2];
                var borderColorStr = (0, utils_1.hslaToStr)([h, s, l, a]);
                /* draw selected rectangle */
                (0, draw_bbox_1.drawBboxes)(context, (0, utils_1.IList)([selectedBbox]), {
                    showPoints: mode === 'rectbox-editor-standby',
                    pointWidthPx: bboxStyle.pointWidthPx,
                    borderWidthPx: bboxStyle.borderWidthPx.selected,
                    borderShadowWidthPx: bboxStyle.boxShadowWidthPx,
                    borderDashLengthPx: mode === 'rectbox-editor-resize-bbox'
                        ? bboxStyle.borderDashLengthPx
                        : undefined,
                    borderColor: borderColorStr
                });
            }
        });
    }, [context, bboxStyle, canvasSize, selectedBbox, mode]);
    return (react_1.default.createElement("canvas", { ref: canvasRef, height: canvasSize.height, width: canvasSize.width }));
});
exports.CanvasBboxSelected.displayName = 'CanvasBboxSelected';
